import {
  Component,
  Host,
  h,
  Element,
  Prop,
} from "@stencil/core";

import {
  StzhVbzMajortickerDisturbanceFetchedEvent,
} from "../../../../index";

/**
 * @slot - Slot any element
 */
@Component({
  tag: "stzh-vbz-carousel",
  styleUrl: "stzh-vbz-carousel.scss",
  scoped: true
})
export class StzhVbzCarousel {
  /** Timeout delay in milliseconds used for autoplay */
  @Prop() autoplayTimeout: number = 9000;

  @Element() element: HTMLStzhFigureElement;

  private majorTicker: HTMLStzhVbzMajortickerElement;

  private hideElement() {
    this.element.hidden = true;
  }

  private onDisturbanceFetched = (event: CustomEvent<StzhVbzMajortickerDisturbanceFetchedEvent>) => {
    if (event.detail.disturbance) {
      this.hideElement();
    }
  }

  async connectedCallback() {
		this.majorTicker = document.querySelector("stzh-vbz-majorticker");

    if (this.majorTicker) {
			const disturbance = await this.majorTicker.getDisturbance();

      if (disturbance) {
        this.hideElement();
      } else {
        this.majorTicker.addEventListener("stzhDisturbanceFetched", this.onDisturbanceFetched);
      }
    }
  }

  disconnectedCallback() {
    if (this.majorTicker) {
      this.majorTicker.removeEventListener("stzhDisturbanceFetched", this.onDisturbanceFetched);
    }
  }

  render() {
    const classes = {
      "stzh-vbz-carousel": true,
    };

    return (
      <Host>
        <div class={classes}>
          <stzh-carousel
            noPeek={true}
            nonInteractive={true}
            preventMouseDrag={true}
            preventAutoplayPause={true}
            preventAutoplayStop={true}
            autoplay
            autoplayTimeout={this.autoplayTimeout}
          >
            <slot></slot>
          </stzh-carousel>
        </div>
      </Host>
    );
  }
}
